import { render } from "./OrgsListing.vue?vue&type=template&id=67fbe5b4&scoped=true"
import script from "./OrgsListing.vue?vue&type=script&lang=js"
export * from "./OrgsListing.vue?vue&type=script&lang=js"

import "./OrgsListing.vue?vue&type=style&index=0&id=67fbe5b4&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67fbe5b4"]])

export default __exports__